import React from 'react';
import { useTabs, TabBar } from './TabManager';
import { useVbMenu, tabButtonOn } from '../utils/vbPerms';
import BudgetCredit   from './Budget/BudgetCredit';    // منابع اعتباری
import BudgetPlan     from './Budget/BudgetPlan';      // طرح‌ها
import BudgetProgram  from './Budget/BudgetProgram';   // برنامه‌ها
import BudgetProject  from './Budget/BudgetProject';   // پروژه‌ها
import BudgetActivity from './Budget/BudgetActivity';  // فعالیت‌ها
import BudgetHazineh  from './Budget/BudgetHazineh';   // کدهای هزینه
import BudgetHazinehCredit from './Budget/BudgetHazinehCredit'; // ثبت اعتبار و تخصیص هزینه‌ای
import BudgetTamalokCredit from './Budget/BudgetTamalokCredit'; // ثبت اعتبار و تخصیص تملک
import BudgetTamalokHavaleh from './Budget/BudgetTamalokHavaleh'; // حواله پرداخت اعتبارات (هزینه‌ای و تملک)
import BudgetPayrolCreditPlace from './Budget/BudgetPayrolCreditPlace'; // تعیین محل اعتبار اقلام حقوق
import BudgetPeopleActivity from './Budget/BudgetPeopleActivity'; // تعیین فعالیت‌های کارکنان
import BudgetProgramShomool from './Budget/BudgetProgramShomool'; // ثبت اعتبار خارج از شمول

/* دکمه‌های منوی بودجه (تب «بودجه») — ترتیب و عنوان‌ها را عوض نکن */
const BUDGET_BUTTONS = [
  /* ── ستون تعاریف (سمت راست منو) ── */
  { key: 'btnCreditSource', vb: 'BTNCREDIT1',  label: 'منابع اعتباری', icon: '💠', bg: 'linear-gradient(135deg,#1b5e20,#2e7d32)', page: 'credit_source' },
  { key: 'btnPlans', vb: 'BTNTAMALOKPROGRAM',         label: 'طرح‌ها',        icon: '📐', bg: 'linear-gradient(135deg,#004d40,#00695c)', page: 'plans' },
  { key: 'btnPrograms', vb: 'BTNJARIPROGRAM',      label: 'برنامه‌ها',     icon: '📚', bg: 'linear-gradient(135deg,#1a237e,#283593)', page: 'programs' },
  { key: 'btnProjects', vb: 'BTNPROJECT1',      label: 'پروژه‌ها',      icon: '🗂️', bg: 'linear-gradient(135deg,#0d47a1,#1565c0)', page: 'projects' },
  { key: 'btnActivities',    label: 'فعالیت‌ها',     icon: '📊', bg: 'linear-gradient(135deg,#006064,#00838f)', page: 'activities' },
  { key: 'btnExpenseCodes', vb: 'BTNHAZINEH1',  label: 'کدهای هزینه',   icon: '🏷️', bg: 'linear-gradient(135deg,#33691e,#558b2f)', page: 'expense_codes' },

  /* ── ستون عملیات (ستون میانی منو) ── */
  { key: 'btnHazinehCredit', vb: 'BTNHAZINEHBUDGETTRANSACTION',  label: 'ثبت اعتبار و تخصیص اعتبارات هزینه ای',            icon: '💰', bg: 'linear-gradient(135deg,#e65100,#f57c00)', page: 'hazineh_credit' },
  { key: 'btnHazinehHavaleh', vb: 'BTNHAZINEHBUDGETHAVALEH', label: 'حواله پرداخت اعتبارات هزینه ای',                  icon: '🧾', bg: 'linear-gradient(135deg,#bf360c,#d84315)', page: 'hazineh_havaleh' },
  { key: 'btnTamalokCredit', vb: 'BTNTAMALOKBUDGETTRANSACTION',  label: 'ثبت اعتبار و تخصیص اعتبارات تملک دارایهای سرمایه ای', icon: '🏛️', bg: 'linear-gradient(135deg,#4a148c,#6a1b9a)', page: 'tamalok_credit' },
  { key: 'btnTamalokHavaleh', vb: 'BTNTAMALOKBUDGETHAVALEH', label: 'حواله پرداخت اعتبارات تملک دارایهای سرمایه ای',   icon: '📑', bg: 'linear-gradient(135deg,#311b92,#4527a0)', page: 'tamalok_havaleh' },
  { key: 'btnPayrolCreditPlace', label: 'تعیین محل اعتبار اقلام حقوق',                  icon: '👥', bg: 'linear-gradient(135deg,#880e4f,#ad1457)', page: 'payrol_credit_place' },
  { key: 'btnPeopleActivity', label: 'تعیین فعالیتهای کارکنان',                         icon: '🧑‍💼', bg: 'linear-gradient(135deg,#37474f,#455a64)', page: 'people_activity' },
  { key: 'btnOutOfScope', vb: 'BTNSHOMOOL1',     label: 'ثبت اعتبار خارج از شمول',                         icon: '➕', bg: 'linear-gradient(135deg,#00695c,#00796b)', page: 'out_of_scope_credit' },
];

/* حواله پرداخت هزینه‌ای همان فرم حواله تملک است با نوع برنامهٔ هزینه‌ای */
const HazinehBudgetHavaleh = props => <BudgetTamalokHavaleh {...props} programType={0} />;

/* زیرصفحه‌های ساخته‌شده — با تکمیل هر بخش اینجا اضافه می‌شود */
const PAGE_COMPONENTS = {
  credit_source: BudgetCredit,   // منابع اعتباری
  plans:         BudgetPlan,     // طرح‌ها
  programs:      BudgetProgram,  // برنامه‌ها
  projects:      BudgetProject,  // پروژه‌ها
  activities:    BudgetActivity, // فعالیت‌ها
  expense_codes: BudgetHazineh,  // کدهای هزینه
  hazineh_credit: BudgetHazinehCredit, // ثبت اعتبار و تخصیص اعتبارات هزینه‌ای
  tamalok_credit: BudgetTamalokCredit, // ثبت اعتبار و تخصیص اعتبارات تملک
  hazineh_havaleh: HazinehBudgetHavaleh, // حواله پرداخت اعتبارات هزینه‌ای
  tamalok_havaleh: BudgetTamalokHavaleh, // حواله پرداخت اعتبارات تملک
  payrol_credit_place: BudgetPayrolCreditPlace, // تعیین محل اعتبار اقلام حقوق
  people_activity:  BudgetPeopleActivity,  // تعیین فعالیت‌های کارکنان
  out_of_scope_credit: BudgetProgramShomool, // ثبت اعتبار خارج از شمول
};

export default function Budget({ user, onBack }) {
  const { openTab, goHome } = useTabs();

  const openSubPage = (btn) => {
    const Comp = PAGE_COMPONENTS[btn.page];
    if (!Comp) { alert(`صفحه "${btn.label}" در حال توسعه است`); return; }
    openTab(`budget:${btn.page}`, btn.label, btn.icon,
      () => <Comp user={user} onBack={goHome} />);
  };

  // دکمه‌های تب: دکمهٔ بی‌مجوز غیرفعال (خاکستری) دیده می‌شود
  const menu = useVbMenu();
  const allowedBtns = BUDGET_BUTTONS.map(btn => ({
    ...btn, _on: tabButtonOn(menu, 'TBBUDGET', btn.vb || btn.key),
  }));
  const enabledCount = allowedBtns.filter(b => b._on).length;

  const gridResponsiveCSS = `@media(max-width:640px){.arjan-acc-grid{grid-template-columns:repeat(2,1fr)!important;gap:16px!important;max-width:360px;margin:0 auto;padding:0 12px;}}`;

  return (
    <><style>{gridResponsiveCSS}</style>
    <div style={s.page}>
      <header style={s.header}>
        <div style={s.hLeft}>
          <button onClick={onBack} style={s.backBtn}>← بازگشت</button>
          <div style={s.hLogo}><img src={require('../assets/images/arjan.png')} alt="ارجان" style={{width:'36px',height:'36px',borderRadius:'8px'}}/></div>
          <div><div style={s.hTitle}>سامانه ارجان</div><div style={s.hSub}>بخش بودجه</div></div>
        </div>
        <span style={s.userName}>{user?.full_name}</span>
      </header>
      <TabBar/>
      <main style={s.main}>
        <div style={s.hero}><div style={s.heroIcon}>💰</div><div><h2 style={s.heroTitle}>بخش بودجه</h2><p style={s.heroSub}>{enabledCount} مورد در دسترس شما</p></div></div>
        {enabledCount > 0 || allowedBtns.length > 0 ? (
          <div className="arjan-acc-grid" style={s.grid}>
            {allowedBtns.map(btn => (
              <div key={btn.key} style={s.btnWrap}>
                <button disabled={!btn._on} style={{...s.btn,background:btn.bg,...(btn._on?{}:DISABLED)}} onClick={()=>btn._on&&openSubPage(btn)}
                  onMouseEnter={e=>{if(!btn._on)return;e.currentTarget.style.transform='translateY(-8px) scale(1.05)';e.currentTarget.style.boxShadow='0 16px 40px rgba(0,0,0,0.35)';}}
                  onMouseLeave={e=>{e.currentTarget.style.transform='translateY(0) scale(1)';e.currentTarget.style.boxShadow='0 8px 24px rgba(0,0,0,0.2)';}}>
                  <span style={s.btnIcon}>{btn.icon}</span>
                </button>
                <div style={s.btnLabel}>{btn.label}</div>
              </div>
            ))}
          </div>
        ) : (<div style={s.noAccess}><div style={{fontSize:'56px',marginBottom:'16px'}}>🔒</div><div style={{fontSize:'16px',color:'#666'}}>دسترسی به این بخش تعریف نشده است</div></div>)}
      </main>
    </div></>
  );
}

const s = {
  page:{minHeight:'100vh',background:'#f0f2f7',fontFamily:"'Vazirmatn',Tahoma,sans-serif",direction:'rtl'},
  header:{background:'linear-gradient(135deg,#0a1628,#1a2f50)',padding:'12px 24px',display:'flex',justifyContent:'space-between',alignItems:'center',boxShadow:'0 2px 16px rgba(0,0,0,0.3)',position:'sticky',top:0,zIndex:100},
  hLeft:{display:'flex',alignItems:'center',gap:'12px'},
  backBtn:{padding:'6px 14px',background:'rgba(255,255,255,0.12)',color:'#fff',border:'1px solid rgba(255,255,255,0.25)',borderRadius:'7px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px'},
  hLogo:{width:'40px',height:'40px',background:'rgba(200,168,75,0.12)',border:'1px solid rgba(200,168,75,0.3)',borderRadius:'9px',display:'flex',alignItems:'center',justifyContent:'center'},
  hTitle:{fontSize:'16px',fontWeight:'700',color:'#fff'},
  hSub:{fontSize:'11px',color:'rgba(255,255,255,0.55)'},
  userName:{fontSize:'13px',color:'rgba(255,255,255,0.85)'},
  main:{padding:'32px 24px',maxWidth:'1100px',margin:'0 auto'},
  hero:{display:'flex',alignItems:'center',gap:'16px',marginBottom:'32px'},
  heroIcon:{fontSize:'40px'},
  heroTitle:{fontSize:'22px',fontWeight:'800',color:'#1a2f50',margin:0},
  heroSub:{fontSize:'13px',color:'#888',margin:'4px 0 0'},
  grid:{display:'grid',gridTemplateColumns:'repeat(4,160px)',gap:'24px',justifyContent:'center'},
  btnWrap:{display:'flex',flexDirection:'column',alignItems:'center',gap:'10px'},
  btn:{width:'100%',aspectRatio:'1',border:'none',borderRadius:'20px',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',boxShadow:'0 8px 24px rgba(0,0,0,0.2)',transition:'all .25s'},
  btnIcon:{fontSize:'36px'},
  btnLabel:{fontSize:'13px',fontWeight:'700',color:'#333',textAlign:'center'},
  noAccess:{textAlign:'center',padding:'60px 20px'},
};

// دکمهٔ تبِ بی‌مجوز دیده می‌شود ولی کار نمی‌کند
const DISABLED = { filter: 'grayscale(1)', opacity: 0.45, cursor: 'not-allowed', boxShadow: 'none' };
